import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Card, Icon, Col, Row, Select, Modal } from 'antd';
import { sanitizerTexto } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import { ShowMenuItem } from '../../util/ShowMenuItem';
import { roles } from '../../util/Roles';
import CatalogoRequest from '../../services/Catalogo';
import CapturaCiclicaRequest from '../../services/CapturaCiclica';
import { get_id } from '../../util/IdUser';
import { Link } from 'react-router-dom';
import { esBarras, getSegmento } from '../../util/generics';
import moment from 'moment';
moment.locale('es')

const { confirm } = Modal;
const { Option } = Select;

const ESTADO_BORRADOR = 'Borrador'

const ESTADO_COLOR = {
    'Borrador': '#F1C40F',
    'Finalizado': '#008F39',
    'Cancelado': '#8c8c8c',
    'Expirado': '#fd1b02ff',
}

export default class ListaCapturaCiclica extends Component {
    state = {
        esBarra: esBarras(),
        arrListaCapturas: [],
        cargando: false,
        creando: false,
        bloquear_diario: true,
        bloquear_semanal: true,
        arrDrives: [],
        driveSelected: undefined,
        disable_combo_drive: false,

        pageMain: 1,
        pageSizeMain: 20,
        totalCountMain: 0,
    }

    componentDidMount = () => {
        const segmento = getSegmento()
        if (!segmento || esBarras() || !ShowMenuItem([roles.AdminCatalogos]) || !ShowMenuItem([roles.Operador])) {
            this.props.history.push({ pathname: "/" })
            return
        }

        CatalogoRequest.CargarSitiosByUsuario(get_id()).then(response => {
            const arrDrives = response.data || []
            this.setState({ arrDrives }, () => {
                if (arrDrives.length === 1) {
                    this.setState({ driveSelected: arrDrives[0].id }, this.onChangeDrive)
                } else {
                    const elSitio = arrDrives.find((item) => item.id == (this.props.match.params.idSitio * 1))
                    if (elSitio != undefined) {
                        this.setState({ driveSelected: elSitio.id }, this.onChangeDrive)
                    }
                }
                if (!arrDrives.length) {
                    openNotification("El usuario no tiene asignado un punto de venta, favor de contactar al Administrador.", "Aviso")
                }
            })
        }).catch(() => {
            openNotification("Ha ocurrido un error al listar los puntos de venta del usuario.", "Error")
        })
    }

    onChangeDrive = () => {
        const { driveSelected } = this.state
        if (!driveSelected) {
            this.setState({ arrListaCapturas: [], totalCountMain: 0, bloquear_diario: true, bloquear_semanal: true })
            return
        }

        this.setState({ pageMain: 1 }, this.cargarCapturas)
    }

    cargarCapturas = () => {
        const { driveSelected, pageMain, pageSizeMain } = this.state
        if (!driveSelected) return

        this.setState({ cargando: true }, () => {
            CapturaCiclicaRequest.ListarCapturas(driveSelected, pageMain, pageSizeMain).then(response => {
                const responseData = response.data?.data || {};
                this.setState({
                    arrListaCapturas: responseData.capturas || [],
                    totalCountMain: responseData.count || 0,
                    cargando: false,
                    bloquear_diario: false,
                    bloquear_semanal: false,
                })
            }).catch(() => {
                this.setState({ cargando: false })
                openNotification("Ha ocurrido un error al listar las capturas del drive seleccionado.", "Error")
            })
        })
    }

    agregarCaptura = (tipoFrecuencia) => {
        const { driveSelected } = this.state
        this.setState({ creando: true }, () => {
            CapturaCiclicaRequest.CrearCaptura(driveSelected, tipoFrecuencia).then(response => {
                this.setState({ creando: false })
                this.props.history.push(`/captura_ciclico_diferencias/${driveSelected}/${response.data.id}`)
            }).catch(err => {
                this.setState({ creando: false })
                openNotification(err?.response?.data?.message, 'Error')
            })
        })
    }

    eliminarCaptura = (record) => {
        this.setState({ cargando: true }, () => {
            CapturaCiclicaRequest.Eliminar(record.id).then(() => {
                openNotification("Captura eliminada correctamente.", "Éxito")
                this.cargarCapturas()
            }).catch(err => {
                this.setState({ cargando: false })
                openNotification(err?.response?.data?.message, 'Error')
            })
        })
    }

    confirmarEliminar = (record) => {
        confirm({
            title: 'Confirmar Eliminar',
            content: <div><b>¿Está seguro de eliminar este registro?</b></div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            onOk: () => this.eliminarCaptura(record),
        });
    }

    render() {
        const columnas = [
            {
                title: "Fecha y hora de captura",
                dataIndex: "fecha_captura",
                key: "fecha_captura",
                render: fecha => <span>{moment(fecha).format("DD/MM/YYYY, h:mm a")}</span>
            },
            {
                title: "Usuario que capturó",
                dataIndex: "usuario_captura",
                key: "usuario_captura",
            },
            {
                title: "Frecuencia",
                dataIndex: "tipo_frecuencia",
                key: "tipo_frecuencia",
                render: (value) => (
                    <span style={{ fontWeight: 'bold' }}>
                        {value === 'diario' ? 'Diario' : 'Semanal'}
                    </span>
                )
            },
            {
                title: "Turno",
                dataIndex: "turno_nombre",
                key: "turno_nombre",
                render: (value) => <span>{value || '-'}</span>
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                render: (value) => (
                    <span style={{ fontWeight: "bold", color: ESTADO_COLOR[value] }}>{value}</span>
                )
            },
            {
                title: 'Acciones',
                dataIndex: 'acciones',
                key: 'acciones',
                render: (_, record) => {
                    const esBorrador = record.estado === ESTADO_BORRADOR
                    return (
                        <div>
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title={esBorrador ? "Editar captura" : "Ver detalles"}>
                                    <Link to={`/captura_ciclico_diferencias/${this.state.driveSelected}/${record.id}`}>
                                        <Button icon={esBorrador ? "edit" : "eye"} className="btnEditar"></Button>
                                    </Link>
                                </Tooltip>
                            </span>
                            <span style={{ marginRight: 5 }}>
                                <Tooltip placement="top" title="Eliminar">
                                    <Button icon="delete" className="btnEditar" disabled={!esBorrador} onClick={() => this.confirmarEliminar(record)}></Button>
                                </Tooltip>
                            </span>
                        </div>
                    )
                }
            }
        ]

        return (
            <Card id="ParentSize"
                title={'Captura de inventario'}
                extra={
                    <Row gutter={[8, 8]}>
                        <Col span={12}>
                            <Button
                                className="btnVerCrearGuardar"
                                disabled={this.state.bloquear_diario}
                                loading={this.state.creando}
                                type="primary"
                                onClick={() => this.agregarCaptura('diario')}
                            > Agregar diario</Button>
                        </Col>
                        <Col span={12}>
                            <Button
                                className="btnVerCrearGuardar"
                                disabled={this.state.bloquear_semanal}
                                loading={this.state.creando}
                                type="primary"
                                onClick={() => this.agregarCaptura('semanal')}
                            >Agregar semanal</Button>
                        </Col>
                    </Row>
                }
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={24}>
                            <Col span={8}>
                                <Tooltip placement="top" title="Punto de venta">
                                    <div className="center">Punto de venta:</div>
                                    <Select
                                        defaultActiveFirstOption={false}
                                        allowClear={this.state.arrDrives?.length > 1}
                                        showSearch
                                        disabled={this.state.disable_combo_drive}
                                        notFoundContent={"No hay opciones"}
                                        style={{ width: "100%" }}
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        filterOption={(input, option) => sanitizerTexto(input, option.props.children)}
                                        value={this.state.driveSelected}
                                        onChange={(value) => this.setState({ driveSelected: value }, this.onChangeDrive)}
                                    >
                                        {
                                            this.state.arrDrives?.length > 0 &&
                                            this.state.arrDrives.map((obj) => (
                                                <Option key={obj.id} value={obj.id}>{obj.nombre}</Option>
                                            ))
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(record) => record.id}
                            columns={columnas}
                            dataSource={this.state.arrListaCapturas}
                            pagination={{
                                current: this.state.pageMain,
                                pageSize: this.state.pageSizeMain,
                                total: this.state.totalCountMain,
                                onChange: (page, pageSize) => {
                                    this.setState({ pageMain: page, pageSizeMain: pageSize }, this.cargarCapturas)
                                },
                                onShowSizeChange: (page, pageSize) => {
                                    this.setState({ pageMain: 1, pageSizeMain: pageSize }, this.cargarCapturas)
                                },
                                showSizeChanger: true,
                                pageSizeOptions: ['10', '20', '50', '100']
                            }}
                        />
                    </Spin>
                </div>
            </Card>
        )
    }
}
